import { useState } from 'react';
import { RichTextEditor } from '@mantine/rte';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { termsAndConditionsText } from '../../data/terms-conditions-text';

const modules = {
  toolbar: false,
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
];
function TermsAndConditions() {
  const [value, setValue] = useState(termsAndConditionsText);

  return (
    <>
      <ReactQuill
        modules={modules}
        formats={formats}
        onChange={setValue}
        value={value}
        readOnly
      />
    </>
  );
}

export default TermsAndConditions;
